import { render, staticRenderFns } from "./UserDepartmentDialog.vue?vue&type=template&id=29838469"
import script from "./UserDepartmentDialog.vue?vue&type=script&setup=true&lang=ts"
export * from "./UserDepartmentDialog.vue?vue&type=script&setup=true&lang=ts"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports